import { render, staticRenderFns } from "./UserMenuDropdown.vue?vue&type=template&id=459360a7&scoped=true&lang=pug"
import script from "./UserMenuDropdown.vue?vue&type=script&lang=js"
export * from "./UserMenuDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserMenuDropdown.vue?vue&type=style&index=0&id=459360a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459360a7",
  null
  
)

export default component.exports